function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.45 60.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.8,2.51C-.06,4.4.05,6.9,1.27,13.26c1.78,9.28,1.73,23.15-.1,26.47-1.53,2.79-1.56,14.44-.04,17.77,1.05,2.3,3.45,3.26,6.34,2.53.55-.14,4.1-.21,7.89-.17,7.26.09,11.85-1.48,13.44-4.58,2.44-4.76,2.19-11.36-.76-20.09-1.6-4.76-3.22-11.34-3.6-14.62-.66-5.84-4.93-16.02-7.64-18.23-.73-.6-3.26-.97-5.61-.83-2.35.14-4.52-.13-4.81-.61C5.28-.86,1.89.11.8,2.51",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97,5.42c0,.62,1.31,4.33,2.9,8.23,1.59,3.91,3.46,9.76,4.16,13l1.26,5.89.92-4c.86-3.77.57-10.53-.88-20.25-.38-2.56-.24-4.25.36-4.25,1.94,0,6.31,10.33,7.34,17.36.58,3.93,1.63,8.94,2.35,11.14l1.3,4-10.25.05-10.25.05-.6-11.55c-.33-6.35-.87-14.23-1.2-17.51-.55-5.39-.45-5.83,1-4.63.88.73,1.61,1.84,1.61,2.46",
    style: {
      fill: "#fdfefe",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.34,11.47c.35,2.71.44,4.73.21,4.5-1.12-1.12-4.39-10.78-3.84-11.34,1.27-1.27,3.02,2.03,3.63,6.84",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.36,40.63c1,2.61.69,10.15-.54,12.84-1.46,3.22-5.23,4.24-15.28,4.15l-7.93-.07-.83-3c-1.3-4.67-1.25-9.04.15-12.41l1.28-3.09h11.27c9.36,0,11.38.27,11.88,1.58",
    style: {
      fill: "#f9f9fa",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.c8790da0ab9a6365052ea364193411ba.svg";
export { ForwardRef as ReactComponent };